import { useEffect, useState } from 'react';

import { CircularProgress, Sheet } from '@mui/joy';
import { useAuthInfo } from '@propelauth/react';
import { Outlet } from 'react-router-dom';

import { useGlobalStore } from '../stores/useGlobalStore';
import useIsCalyxTeamMember from '../utils/hooks/useIsCalyxTeamMember';

import { Layout } from './Layout';

interface PropTypes {
  hideLayout?: boolean;
}

const FullScreenSpinner = () => {
  return (
    <Sheet
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
      }}
    >
      <CircularProgress size='lg' />
    </Sheet>
  );
};

const ProtectedRoute: React.FC<PropTypes> = ({ hideLayout = false }) => {
  const setRedirectionUrl = useGlobalStore((s) => s.setRedirectionUrl);
  const user = useGlobalStore((s) => s.user);
  const setUser = useGlobalStore((s) => s.setUser);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const authInfo = useAuthInfo();
  const calyxTeam = useIsCalyxTeamMember();

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        setIsLoading(true);
        setUser({
          company: authInfo.orgHelper?.getOrgs()?.[0]?.orgName as string,
          country: authInfo?.user?.properties?.country as string,
          mfa: authInfo?.userClass?.hasMfaEnabled as boolean,
          name: authInfo?.user?.firstName as string,
          surname: authInfo?.user?.lastName as string,
          profile_image: authInfo?.user?.pictureUrl as string,
          user_id: authInfo?.user?.userId as string,
          email: authInfo?.user?.email as string,
          calyx_team: calyxTeam,
          project_access_type: authInfo.orgHelper?.getOrgs()?.[0]?.userAssignedRole as string,
          user_permissions: authInfo.orgHelper?.getOrgs()?.[0]?.userPermissions as string[],
          user_roles: authInfo.orgHelper?.getOrgs()?.[0]?.userAssignedAdditionalRoles as string[],
          user_category: authInfo?.user?.properties?.user_category as string,
          credit_retirement_volume: authInfo?.user?.properties?.annual_credit_volume as string,
          subscription_end_date: authInfo?.user?.properties?.subscription_end_date as string,
          company_type: '',
          compass_modules_access: [],
          ratings_access_type: '',
          user_type: '',
          compass_access_type: '',
        });
      } catch (err) {
        setUser(null);
        return;
      } finally {
        setIsLoading(false);
      }
    };
    fetchUserInfo();
  }, []);

  if (isLoading) return <FullScreenSpinner />;

  if (!!user?.user_id)
    return hideLayout ? (
      <Outlet />
    ) : (
      <Layout>
        <Outlet />
      </Layout>
    );
  setRedirectionUrl(`${window.location.pathname}${window.location.search}`);
};

export { ProtectedRoute };
